<section *ngIf="!loading" class="">
	<div class="w-full flex flex-col gap-2 justify-center items-center p-4">
		<div class="w-full flex flex-col items-center">
			<h2 class="fb-sub-header fb-font-dm text-lg sm:text-xl black-text font-medium lg:px-10 mb-2">
				Hear from our Customers
			</h2>
			<div class="flex items-center gap-1 cursor-pointer">
						<span *ngFor="let _ of stars; let i = index">
							<span class="star" [class.filled]="rating > i">&#9733;</span>
						</span>
				<span>{{rating}} out of 5</span>
			</div>
			<div *ngFor="let review of reviewList" class="w-full md:w-[80%] mt-2">
				<div class="flex flex-col gap-2 my-1">
					<div class="flex justify-between items-center">
						<div class="flex items-center gap-2">
							<img class="w-10 h-10"
								 [src]="'https://ui-avatars.com/api/?rounded=true&background=B8A88F&color=fff&name=' + review.name"
								 alt="Reviewer Avatar">
							<div class="flex flex-col">
								<p class="text-sm black-text font-bold capitalize">
									{{ review.name }}
								</p>
								<div class="flex items-center gap-1">
								<span *ngFor="let _ of stars; let i = index">
									<span class="star" [class.filled]="review.rating > i">&#9733;</span>
								</span>
								</div>
							</div>
						</div>
						<div class="text-xs text-end text-gray-600">
							{{ review.createdAt |  date: 'dd MMM YYYY' }}
						</div>
					</div>
					<div class="text-xs md:text-sm text-gray-600 font-medium">
						<a *ngIf="review.link && review.description"
						   target="_blank"
						   href="{{review.link}}"
						   class=" cursor-pointer">
							<q>{{ review.description }}</q>
						</a>
						<p *ngIf="!review.link"
						   class=" ">
							<q>{{ review.description }}</q>
						</p>
					</div>
					<div class="flex justify-between items-center gap-2">
						<div class="flex items-center gap-1.5">
							<div>
								<img *ngIf="review.productImages != ''"
									 [src]="review.productImages!.split(',')[0]"
									 (click)="onUserProvidedImagesClick(review)"
									 alt=""
									 class="w-[35px] md:w-[50px] rounded border-2 border-[#6c5b48] cursor-pointer object-contain">
								<img *ngIf="review.productImages == ''"
									 src="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/logo-brown.svg"
									 alt=""
									 class="w-[35px] md:w-[50px]  rounded border-2 border-[#6c5b48] object-contain">
							</div>
							<div class="flex flex-col">
								<p class="text-xs text-gray-600 font-bold capitalize">
									Purchased Item
								</p>
								<a *ngIf="review.product"
								   [href]="prepareProductRedirectionUrl(review.product)"
								   target="_blank"
								   class="text-xs primary-brown-text font-medium underline cursor-pointer">
									{{ (review.product.sku) }}
								</a>
							</div>
						</div>
						<div class="flex items-center gap-1">
							<p *ngIf="review.city" class="text-xs md:text-sm text-gray-600 capitalize">
								{{ review.city }},
							</p>
							<p *ngIf="review.country" class="text-xs md:text-sm text-gray-600 capitalize">
								{{ review.country }}
							</p>
						</div>
					</div>
					<div class="border-b border-[#EDEDFD] h-[1px] mt-1 mb-0.5">

					</div>
				</div>
			</div>
			<div class="w-full flex justify-end md:justify-center items-center">
				<a href="/review"
				   target="_blank"
				   class="text-xs md:text-sm rounded primary-brown-text font-medium cursor-pointer border border-[#D1D4DB] py-1 px-3 flex items-center gap-1">
					View All Reviews
					<svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M8.54036 6.98577L5.34985 4.09827L6.04274 3.47119L9.92614 6.98577L6.04274 10.5004L5.34985 9.87327L8.54036 6.98577Z" fill="#7D5A20"/>
					</svg>

				</a>
			</div>

		</div>
	</div>
	<lightgallery
		#lightGallery
		[settings]="settings"
		[onInit]="onInit"
	>
	</lightgallery>
</section>
